
export class InfoSetNames {
	public static SystemInfo = "system-info";
	public static IpAddressTable = "ip-info";	// If you change this value, sync it with ObjSerStrings.IpAddressTable
	public static IfArpTable = "if-arp-info";
	public static IfTable = "if-info";
	public static BridgePortTable = "bp-info";
	public static BaseBridgeAddressTable = "bbridge-info";
	public static LagTable = "lag-info";
	public static BridgePortFdbTable = "bp-fdb-info";
	public static PortLldpTable = "port-lldp-info";
	public static IpRouteTable = "ip-route-info";
	public static StpPortTable = "stp-port-info";
	public static VlanTable = "vlan-info";
	public static IfCdpTable = "if-cdp-info";
	public static ApTable = "ap-info";
	public static ApIfTable = "ap-if-info";
	public static ApClientTable = "ap-client-info";
	public static IpPhoneTable = "ip-phones-info"; // MANAGER of IP PHONES
	public static IpPhoneInfo = "ip-phone-info"; // SINGLE IP PHONE info
	public static PrinterInfo = "printer-info";
	public static AssetTable = "asset-info";
	public static EntPhysicalTable = "entity-info";
	public static MacAddressTable = "mac-address-info";
	public static VirtualHostTable = "vhs-info";
	public static VirtualHostInfo = "vh-info";
	public static VirtualMachineTable = "vms-info";
	public static VirtualMachineInfo = "vm-info";
	public static VirtualSwitchTable = "vsw-info";
	public static VrrpTable = "vrrp-info";
	public static IpV6_IfTable = "ipv6-if-info";
	public static ProductInfo = "product-info";
	public static InstalledSoftwareTable = "inst-sw-info";
	public static RunningProcessTable = "run-process-info";
	public static AttributeInfo = "attr-info";
	public static AddressInfo = "addr-info";
	public static ConfigInfo = "config-info";
	public static DhcpScopeTable = "dhcp-scp-info";
	public static StorageTable = "storage-info";

	public static ComputerSystemInfo = "comp-sys-info";
	public static OperatingSystemInfo = "os-info";

	public static Win32_ComputerSystemInfo = "w32-comp-sys-info";
	public static Win32_OperatingSystemInfo = "w32-os-info";
	public static Win32_BIOSInfo = "w32-bios-info";
	public static Win32_ProcessorTable = "w32-proc-info";
	public static Win32_ProcessTable = "w32-process-info";
	public static Win32_PhysicalMemoryTable = "w32-phys-mem-info";
	public static Win32_DiskDriveTable = "w32-ddrv-info";
	public static Win32_LogicalDiskTable = "w32-ldsk-info";
	public static Win32_InstalledSoftwareTable = "w32-inst-sw-info";
	public static Win32_NetworkAdapterTable = "w32-net-ad-info";
	public static Win32_NetworkAdapterConfigTable = "w32-net-ad-cfg-info";

	public static CpuTable = "cpu-info";
	public static CpuStatsLog = "cpu-stats-log";
	public static CpuStatsTable = "cpu-stats-info";
	public static IfStatsLog = "if-stats-log";
	public static IfStatsTable = "if-stats-info";

	public static SensorTable = "sensor-info";
	public static SensorStatsTable = "sensor-stats-info";

	public static PingStatsTable = "ping-stats-info";
	public static PortStatusTable = "port-st-info";

	public static MonitorStateHistory = "mon-st-hist";

	public static MonitorStatsTable = "mon-stats-table";
	// PARENT INFO-SET
	public static MonitorTable = "mon-info";
	public static PingMonitorTable = "ping-mon-info";

	public static IpHistoryTable = "ip-history-table";
	public static IfLinkHistoryTable = "if-link-history-table";

	public static PrtgStatsLog = "prtg-stats-log";
	public static PrtgStatsTable = "prtg-stats-info";

	public static PrtgDeviceTable = "prtg-device-info";

	public static NotesInfo = "notes-info";
}
